const styles = () => ({
  table: {
    minWidth: 650
  }
});

export default styles;
